const calendarConfig = {
  mainTitle: 'Calendar',
  titleIcon: 'MdCalendar',
  subHeading: 'Page to view and change peak, off peak days and available time slots. To select, long press a start date and then long press the end date',
  tabs: ['Calendar', 'List'],
  actionsSection: (type) => type === 'selectRange' ? 'Create Range' : 'Select Dates',
  timeslotsSection: 'Time Slots',
  keysSection: 'Keys',
  warningTitle1: 'Not finished',
  warningContent1: 'Please mark all of the days as peak or not peak'
}

export default calendarConfig;
